// src/lib/accountGate.js
//
// Shared "does this email already have an account" check.
//
// Accounts are created by saving a calculator estimate or a triage
// snapshot (via claim-session) — never by visiting a sign-in screen.
// Every sign-in entry point that's meant for returning users only
// (SignInModal, /auth) calls this same function rather than each
// re-querying `profiles` (now the email_has_account RPC, migration 018) and re-deciding independently whether to allow
// account creation. If that policy ever changes, it changes in one place.

import { supabase } from './supabase'

export async function requireExistingAccount(email, notFoundMessage) {
  const { data: hasAccount, error } = await supabase.rpc('email_has_account', {
    p_email: email.trim().toLowerCase(),
  })

  if (error) throw new Error('Something went wrong. Please try again.')
  if (!hasAccount) {
    throw new Error(notFoundMessage || 'No account found for that email.')
  }
}
